module.exports = __webpack_public_path__ + "static/media/library.1211d121.jpg";